import ForceGraph3D from '3d-force-graph';
import {CSS2DRenderer, CSS2DObject} from 'three/addons/renderers/CSS2DRenderer.js';
import {ref, reactive, toRaw} from 'vue';
import * as THREE from 'three';
// 2. 导入函数和对象
import { colorMap, createNodeGeometry} from '../configs/shapeConfig';
// 数据以及其他全局变量
// import myData from "../test_kage.json";
// import myData from "../test_kage_v20250630 copy.json";
import myData from "../test_kage_v20251013.json";
import {ElMessage} from "element-plus";
import {categoryInfo} from "@/configs/legendConfig";
import {labelConfig, } from "@/configs/graphConfig";

export {myData};

// 当前节点位置的计算方式
// - weight ：直接影响连接的节点之间的距离，weight越大，节点间距离越近
// - degree ：影响节点的"质量"，degree越大，节点越稳定，成为其他节点的参考点
// - 与图中已存在节点的电荷力（排斥力）
// - 与其他节点的链接力
// - 全局的力导向布局算法
// 目前处理线的距离或节点距离的方式
// - myGraph.d3Force('charge').strength(-300) 调整节点之间的电荷力, 负值代表节点直接的斥力变大, 正代表引力变大, 会变相拉长或缩短线的长度
// - myGraph.d3Force('link').distance(100) 调整所有节点与这个节点的距离为100
// - 或者可以不决定直线的距离, 而是转而调整节点的x、y、z相对于父节点的位置来确定直线与节点的距离

export const currentData = ref({});

export const state = {
    labelNeedUpdateVisibility: 1, // 初始进行标签刷新
    cameraOrigDist: 900,
    selectedIdSet: new Set(["PheCode:335 / C0026769", "PheCode:714.1 / C0003873"]),  // 选中相应的节点id, 始终显示label且标红
    selectedCategoriesSet: new Set(["Disease Codified", "Disease NLP"])
    // myData: null, // 初始化为null, 恢复到以前就注释掉这个
};


// 4 搜索相关
// 搜索层数和数量设定, 6个键值对代表最大搜索到第6层, 左边是层数, 右边是阈值, 0代表显示所有连接, 1代表完全不显示连接, 层数和阈值可以手动调节
// 若想增加层数, 只需要在depthThresholdMap中增加键值对, 例如[7,0.69], 表示最大搜索到第7层
// 阈值层层递进数值越来越大, 这样代表越深的层数, 显示的连接点越少
// 阈值参考json数据中的links中的weight, 假设阈值为0.5, 代表weight>=0.5的所有结点都会被显示出来, <0.5的则会被隐藏
export const depthThresholdMap = new Map([
    [1, 0],
    [2, 0.50],
    [3, 0.56],
    [4, 0.64],
    [5, 0.65],
    [6, 0.68],
])

// 4.1 表单数据
export const formData = reactive({
    // The displayed node id
    nodeOfInterestIdArray: [],   //存储搜索框中选中的结点id
    // Search depth
    depth: 1,  // 搜索深度, 可以通过按钮动态调整
    // Threshold
    minThreshold: depthThresholdMap.get(2),  //搜索深度2的weight阈值
})

// 4. 响应式状态管理
// 4.1 类别选择状态
export const nodeRelativeCategoryMap = ref([])   // Collect Node Relative Categories in need of visibility updates

export const selectedCategory = ref(categoryInfo.map(item => item.db_category));
// 定义几何体边缘线条的材质, 白色, 宽度1, 透明度0.7
export const edgeMaterial = new THREE.LineBasicMaterial({color: 0x202162, linewidth: 1, opacity: 0.3, transparent: true}); // White outline


// 2. 核心图实例初始化
export let myGraph = ForceGraph3D({
    controlType: "trackball",
    extraRenderers: [new CSS2DRenderer()],
}).showNavInfo(false)

// 5.4 计算点到原点的距离
export function calcDistFromOrig(x, y, z) {
    return Math.sqrt(x * x + y * y + z * z);
}

// 5. 3d图显示区域相关
// 5.1 加载等待白屏参数
export const fullscreenLoading = ref(true)

/**
 * After recording the zoomTOFit, the distance between the camera and the origin (at maximum viewing Angle)
 */
// 5.6.1 定义虚线的材质
export const lineMaterialDash = new THREE.LineDashedMaterial({
    color: 0xFFFFFF,
    opacity: 5.10,
    linewidth: 1, //Due to limitations of the OpenGL Core Profile with the WebGL renderer on most platforms linewidth will always be 1 regardless of the set value.
    transparent: true,
    dashSize: 8,
    gapSize: 8,
});

// 5.6.2 定义实线材质
export const lineMaterialSolid = new THREE.LineBasicMaterial({
    opacity: 0.2,
    linewidth: 1, //Due to limitations of the OpenGL Core Profile with the WebGL renderer on most platforms linewidth will always be 1 regardless of the set value.
    transparent: true,
});

/**
 * Setup and then Return mesh for each of the nodes
 * @param node Date
 * @param labelVisNodeSizeThreshold The Threshold decided whether the label of a node is visible
 * @returns {Mesh}
 */
// 5.8 缓存节点材质, 如标签, 几何体, 边缘, 避免重复创建材质, 节省性能 
const categoryGeometryCache = new Map();  // 按类别缓存几何体
const cacheNodeLabel = new Map();         // 标签仍然需要按节点ID缓存
const categoryEdgesCache = new Map();     // 按类别缓存边缘线条
const cacheNodeMaterial = new Map();
colorMap.forEach((color, category) => {
    let nodeMaterial = new THREE.MeshPhysicalMaterial({
        color: colorMap.get(category) ? colorMap.get(category) : 'white',
        side: THREE.FrontSide, // 只渲染几何体对象正面, 但由于旋转, 所以按帧实时渲染
    });
    cacheNodeMaterial.set(category, nodeMaterial)
})

/**
 * Construct Three line objects according to the link source and target.
 * If the value is small and minThreshold, it is displayed as a dashed line
 * @param link
 * @param minThreshold
 */

// 创建两个点的连线, 返回线的3d对象 v2.0 (避免重复创建line的材质)
const lineMaterialCache = new Map();

function getCachedLineMaterial(isDash, opacity) {
    const key = `${isDash ? 'dash' : 'solid'}-${opacity.toFixed(2)}`; // 限制小数位数减少key数量

    if (!lineMaterialCache.has(key)) {
        // 克隆基础材质并设置新属性
        const baseMaterial = lineMaterialSolid.clone();
        baseMaterial.opacity = opacity;
        baseMaterial.transparent = opacity < 1;
        lineMaterialCache.set(key, baseMaterial);
    }

    return lineMaterialCache.get(key);
}

export function getLinkThreeObject(link, minThreshold, opacityCoef) {

    const isDash = link.weight < minThreshold;
    const opacity = link.weight * opacityCoef * 1.5;


    let material;

    // 获取缓存材质
    if (link.source.category == "colorgroup" || link.target.category == 'colorgroup') {
        material = getCachedLineMaterial(isDash, 0); // 如果有一个节点是colorgroup类型的节点就隐藏与之相连的边
    } else {
        material = getCachedLineMaterial(isDash, opacity);
    }

    // 创建几何体
    const points = [
        new THREE.Vector3(link.source.x, link.source.y, link.source.z),
        new THREE.Vector3(link.target.x, link.target.y, link.target.z)
    ];
    const lineGeometry = new THREE.BufferGeometry().setFromPoints(points);

    // 创建线对象
    const line = new THREE.Line(lineGeometry, material);
    line.computeLineDistances();

    return line;
}

// 更新节点, 使用钩子时直接调用, 搜索结果更新, 类别筛选也会调用, 总结就是mydata数据被改变时也会调用
// mydata的数据被改变, 比如我右侧筛选框去掉了某些类别内容, 或者增加了某些类别(categoryInfo)内容, 调用这个函数来重新计算mydata的数据, 
// 具体的做法是去掉或增加mydata中的数据, 然后返回一个新的数据, 然后这个新的数据去图例里显示, 返回的是临时变量, 旧的mydata不会真的被修改
// 也就是说 这个网页在运行中, 总会保存一份完整的test.json中的数据, 用以在类别改变后, 对数据做修改, 然后生成的新数据用于图例的显示
export function updateNodeRelativeCategory(networkData) {
    let nodeCateMap = new Map()
    networkData.nodes.forEach(node => {
        nodeCateMap.set(node.id, node.category)
    })
    let dict = new Map()
    networkData.links.forEach(link => {
        let tmpSet = new Set()
        if (dict.has(link.source)) {
            tmpSet = dict.get(link.source)
        }
        tmpSet.add(nodeCateMap.get(link.target))
        dict.set(link.source, tmpSet)

        tmpSet = new Set()
        if (dict.has(link.target)) {
            tmpSet = dict.get(link.target)
        }
        tmpSet.add(nodeCateMap.get(link.source))
        dict.set(link.target, tmpSet)
    })
    return dict
}

// 参考size修改节点大小, 保留2位小数, 最小值为3
// export function nodeSizeFunc(node) {
//     const originalSize = Math.round((node.size + 2) * 0.25 * 100) / 100;
//     // 根据原始大小计算缩放后的大小
//     let scaledSize = Math.max(Math.min(maxNodeScale, originalSize), minNodeScale);
//
//     if (state.selectedIdSet.has(node.id)) {
//         scaledSize = scaledSize * 2.5;
//     }
//
//     return scaledSize;
// }

export function nodeSizeFunc(node) {
    const rawSize = node.size; // 原始范围 [4,20]

    // 步骤1: 归一化
    const norm = (rawSize - 4) / 16;  // [0,1]

    // 步骤2: 非线性映射
    const alpha = 3.2;  // 固定经验值，让均值 ~6
    const enhanced = Math.pow(norm, alpha);

    // 步骤3: 映射回 [4,20]
    let scaledSize = 1 + enhanced * 7;

    // 选中节点放大
    if (state.selectedIdSet.has(node.id)) {
        scaledSize *= 1.2;
    }

    return scaledSize;
}




// 创建3d对象的核心函数
// 这个函数是创建单个节点的3d对象的函数, 包括节点的标签名, 节点的几何体形状数据以及材质和边的线条, 每生成一个节点, 都需要调用一次

export function getNodeThreeObject(node, selectedIdSet, labelVisNodeSizeThreshold) {
    // 1. 创建或获取节点标签(标签即节点的名字, term)
    // 缓存问题: 可能缓存不是必要的, 这里缓存的是节点标签, 而节点标签是唯一的
    let nodeLabel;
    if (cacheNodeLabel.has(node.id)) {    // 如果节点标签在缓存中
        nodeLabel = cacheNodeLabel.get(node.id)  // 直接获取节点标签
    } else {
        const labelDiv = document.createElement('div'); // 否则创建一个div
        // if (selectedIdSet.has(node.id)) {  // 并且判断这个节点标签是否在selectedIdSet中
        //     labelDiv.className = "nodehighlight"; // 如果在, 则加一个class为nodehighlight的样式(节点标签标红色背景)
        // } else {
        //     labelDiv.className = "nodelabel"; // 否则加一个class为nodelabel的样式(节点标签标黑色背景)
        // }

        labelDiv.className = "nodelabel";

        // div的内容是节点的名字, term
        // 标签过长截断
        if (node.term && node.term.length > 40) {
            labelDiv.innerHTML = node.label.substring(0, 39) + "...";
        } else {
            labelDiv.innerHTML = node.label;
        }


        nodeLabel = new CSS2DObject(labelDiv); // 将div转换为CSS2DObject对象
        nodeLabel.position.set(0, -4, 0); // 设置节点标签相对于节点的位置
        cacheNodeLabel.set(node.id, nodeLabel) // 将节点标签缓存
    }

    // 2. 创建或获取节点几何体
    // 关于视觉上缩小节点大小的问题, 可能由于原来的节点显示太大, 所以需要缩小(test.json中nodes的size属性)
    let geometry;
    const cacheKey = `${node.shape}_${nodeSizeFunc(node)}`;
    if (categoryGeometryCache.has(cacheKey)) { // 如果节点几何体形状在缓存中
        geometry = categoryGeometryCache.get(cacheKey) // 直接获取节点几何体
    } else {
        // let nodeSize = 3; // 视觉上调整节点大小, 统一size
        let nodeSize = nodeSizeFunc(node); // 视觉上调整节点大小
        geometry = createNodeGeometry(node.shape, nodeSize); // 创建节点几何体形状
        categoryGeometryCache.set(cacheKey, geometry); // 缓存该形状
    }

    // 3. 创建完整3d节点
    // 材质包含节点颜色, 质感, 反光, 透明度等
    // mesh是3d对象, 包含几何体形状(geometry)和材质(nodeMaterial)
    // edgesGeometry几何体边缘线条数据, edgeMaterial几何体边缘线条材质(白色, 宽度1, 透明度0.7), edges把两者结合, 形成几何体边缘线条对象
    // 如果是立方体或圆柱体, 则创建几何体的线条, 也就是添加一层白色的边框, 增加图形立体感
    let nodeMaterial;

    // 为 colorgroup 节点创建完全透明的材质
    if (node.category === 'colorgroup') {
        nodeMaterial = new THREE.MeshPhysicalMaterial({
            color: 0x000000,
            transparent: true,
            opacity: 0, // 完全透明
            side: THREE.FrontSide,
        });
    } else {
        nodeMaterial = cacheNodeMaterial.get(node.category); // 获取节点材质
    }

    let mesh = new THREE.Mesh(geometry, nodeMaterial);

    // 为 colorgroup 节点隐藏边缘线条
    if (node.shape !== 'sphere') {
        if (node.category !== 'colorgroup') { // 只为非 colorgroup 节点添加边缘
            let edges;
            // 使用与几何体相同的缓存key，包含节点大小信息
            const edgesCacheKey = `${node.shape}_${nodeSizeFunc(node)}`;
            if (categoryEdgesCache.has(edgesCacheKey)) {
                edges = categoryEdgesCache.get(edgesCacheKey).clone();
            } else {
                const edgesGeometry = new THREE.EdgesGeometry(geometry);
                edges = new THREE.LineSegments(edgesGeometry, edgeMaterial);
                categoryEdgesCache.set(edgesCacheKey, edges)
            }
            mesh.add(edges);
        }
    }

    // TODO: Modify logic to select the closest 40 points + the largest 40 points(未来计划)
    // 根据节点大小(size作为阈值的参考)(节点与相机的距离远近), 来决定标签是否可见
    // mesh可以包含多种对象, 如geometry (几何体形状) material (材质) edges (边缘线条) nodeLabel (CSS2DObject标签)
    // 隐藏 colorgroup 节点的标签
    if (node.labelshow || selectedIdSet.has(node.id)) {
        nodeLabel.visible = true;
    } else {
        if (labelVisNodeSizeThreshold === -1) {
            nodeLabel.visible = false;
        } else {
            if (node.category === 'colorgroup') {
                nodeLabel.visible = false;
            } else {
                nodeLabel.visible = node.size >= labelVisNodeSizeThreshold;
            }
        }
    }

    mesh.add(nodeLabel);
    node.mesh = mesh
    node.nodeLabel = nodeLabel
    return mesh;
}

// 5.10 根据相机位置, 来决定节点label是否可见(包括平移相机(3d是旋转效果)和前后移动相机)
export function isInView(myGraph, node) {
    var ele = document.getElementById("network-canvas")
    const ScreenCoords = myGraph.graph2ScreenCoords(node.x, node.y, node.z);
    if (ScreenCoords.x >= 0 && ScreenCoords.x <= ele.clientWidth &&
        ScreenCoords.y >= 0 && ScreenCoords.y <= ele.clientHeight
    ) {
        return true
    } else {
        return false
    }
}

// 存储初始可见节点（hidden = false） 和 hidden == false2 的集合
export const initialVisibleNodeIds = new Map();
export const colorgroupVisibleNodeIds = new Map();

export function initializeGraphData(fullData) {

    initialVisibleNodeIds.clear();
    colorgroupVisibleNodeIds.clear();

    // 过滤出可见节点
    const visibleNodes = [];
    const visibleNodeIds = new Set();
    const colorsonVisibleNodes = [];
    const colorsonvisibleNodeIds = new Set();

    fullData.nodes.forEach(node => {
        if (!node.hidden) {
            const newNode = JSON.parse(JSON.stringify(node));
            visibleNodes.push(newNode);
            visibleNodeIds.add(node.id);
            initialVisibleNodeIds.set(node.id, true);
        }
    });

    fullData.nodes.forEach(node => {
        if (node.hidden == 'false2') {
            const newNode = JSON.parse(JSON.stringify(node));
            colorsonVisibleNodes.push(newNode);
            colorsonvisibleNodeIds.add(node.id);
            colorgroupVisibleNodeIds.set(node.id, true);
        }
    });
    // 规范格式打印当前默认显示的nodes
    console.log('initialVisibleNodeIds:', Object.fromEntries(initialVisibleNodeIds));
    console.log('colorgroupVisibleNodeIds:', colorgroupVisibleNodeIds);

    // 过滤出连接两个可见节点的边
    const visibleLinks = fullData.links.filter(link => {
        const sourceId = typeof link.source === 'object' ? link.source.id : link.source;
        const targetId = typeof link.target === 'object' ? link.target.id : link.target;
        return visibleNodeIds.has(sourceId) && visibleNodeIds.has(targetId);
    });

    return {
        nodes: visibleNodes,
        links: visibleLinks
    };
}

// 记录节点的展开状态
export const expandedNodesMap = new Map();

// 初始化时，将 selectedIdSet 中的节点加入 Map
state.selectedIdSet.forEach(nodeId => {
    expandedNodesMap.set(nodeId);
});

// 判断节点是否已展开
export function isNodeExpanded(nodeId) {
    return expandedNodesMap.has(nodeId);
}

// 切换节点的展开/收起状态
export function toggleNodeExpanded(nodeId) {
    if (expandedNodesMap.has(nodeId)) {
        expandedNodesMap.delete(nodeId);  // 如果存在就删除
        return false;
    } else {
        expandedNodesMap.set(nodeId);     // 如果不存在就添加
        return true;
    }
}

// 判断是否是人造集中节点
export function isColorgroup(category) {
    return category === 'colorgroup';
}

// 添加透明度配置
export const lineOpacityCoef = ref(10); // 默认值设为10%

// 跳转到外部URL
export const baseUrl = ref('https://shiny.parse-health.org/KAGE/?node='); // 响应式的基础URL
export function navigateToNodeUrl(nodeId) {
    // 使用Vue的响应式数据构建目标URL
    const targetUrl = baseUrl.value + encodeURIComponent(nodeId);

    // 在新窗口中打开URL
    window.open(targetUrl, '_blank');

    // 可选：触发一个事件或更新状态来记录跳转行为
    console.log(`导航到节点: ${nodeId}, URL: ${targetUrl}`);
}


// 添加一个简单的哈希函数
function simpleHash(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // 转换为32位整数
    }
    return Math.abs(hash);
}

// 基于种子的伪随机数生成器
function seededRandom(seed) {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
}

// export function countColorPosition(colorgroup) {
//     // 创建并加载 colorSon 数据
//     const colorSon = new Map();
//     Object.entries(colorgroup.colorgroups).forEach(([category, targets]) => {
//         colorSon.set(category, targets);
//     });
//     const radius = 80;
//     const currentGraphData = myGraph.graphData();
//
//     const allChildNodes = [];
//     const allChildLinks = [];
//     const currentNodeIds = new Set(currentGraphData.nodes.map(node => node.id));
//
//     // 收集所有子节点ID
//     const allChildNodeIds = new Set();
//     colorSon.forEach((childNodeIds) => {
//         childNodeIds.forEach(id => allChildNodeIds.add(id));
//     });
//
//     colorSon.forEach((childNodeIds, parentNodeId) => {
//         // 从当前图表中查找父节点的实际位置
//         const parentNode = currentGraphData.nodes.find(node => node.id === parentNodeId);
//         if (!parentNode) return;
//
//         // 获取子节点数据
//         const childNodes = myData.nodes.filter(node => childNodeIds.includes(node.id));
//
//         childNodes.forEach((childNode, index) => {
//             // 使用节点ID和索引生成确定性的种子
//             const seed1 = simpleHash(childNode.id + '_theta') + index;
//             const seed2 = simpleHash(childNode.id + '_phi') + index;
//
//             // 使用确定性的随机数
//             const theta = seededRandom(seed1) * 2 * Math.PI;
//             const phi = Math.acos(2 * seededRandom(seed2) - 1);
//
//             // 球坐标转换为笛卡尔坐标，基于父节点的实际位置
//             childNode.fx = parentNode.x + radius * Math.sin(phi) * Math.cos(theta);
//             childNode.fy = parentNode.y + radius * Math.sin(phi) * Math.sin(theta);
//             childNode.fz = parentNode.z + radius * Math.cos(phi);
//
//             // 创建子节点与父节点之间的链接
//             allChildLinks.push({
//                 source: parentNodeId,
//                 target: childNode.id,
//                 weight: 0.8
//             });
//         });
//
//         allChildNodes.push(...childNodes);
//     });
//
//     // 查找子节点与现有节点之间的所有链接关系
//     myData.links.forEach(link => {
//         const sourceId = typeof link.source === 'object' ? link.source.id : link.source;
//         const targetId = typeof link.target === 'object' ? link.target.id : link.target;
//
//         // 如果source是子节点，target是当前图表中的节点（不包括其他子节点）
//         if (allChildNodeIds.has(sourceId) && currentNodeIds.has(targetId)) {
//             allChildLinks.push({
//                 source: sourceId,
//                 target: targetId,
//                 weight: link.weight
//             });
//         }
//
//         // 如果target是子节点，source是当前图表中的节点（不包括其他子节点）
//         if (allChildNodeIds.has(targetId) && currentNodeIds.has(sourceId)) {
//             allChildLinks.push({
//                 source: sourceId,
//                 target: targetId,
//                 weight: link.weight
//             });
//         }
//
//         // 子节点之间的链接
//         if (allChildNodeIds.has(sourceId) && allChildNodeIds.has(targetId)) {
//             allChildLinks.push({
//                 source: sourceId,
//                 target: targetId,
//                 weight: link.weight
//             });
//         }
//     });
//
//     // 返回包含节点和链接的完整数据
//     return {
//         nodes: allChildNodes,
//         links: allChildLinks
//     };
// }


export function handleNodeClick(node) {

    let parentSet = new Map(Object.entries(toRaw(currentData.value.parent_child)));

    if (!parentSet.has(node.id)) {
        ElMessage.info("This node doesn't have a child node.")
        return false;
    }



    let childList = parentSet.get(node.id);

    const isExpanded = toggleNodeExpanded(node.id);

    if (isExpanded) {

        const graphData = myGraph.graphData();

        // 固定现有节点
        graphData.nodes.forEach(n => {
            n.fx = n.x;
            n.fy = n.y;
            n.fz = n.z;
        });

        const visibleNodeIds = new Set(graphData.nodes.map(n => n.id));
        const newNodes = [];

        const existingLinks = new Set(graphData.links.map(link => {
            const sourceId = typeof link.source === 'object' ? link.source.id : link.source;
            const targetId = typeof link.target === 'object' ? link.target.id : link.target;
            return `${sourceId}-${targetId}`;
        }));


        // 第一步：找出需要添加的新节点 ()
        currentData.value.nodes.forEach(n => {
            if (childList.includes(n.id)) {
                newNodes.push(toRaw(n));
                visibleNodeIds.add(n.id);
            }
        });


        // 第二步: 获取当前所有可见节点之间的连接
        const allLinks = [];

        currentData.value.links.forEach(link => {
            const sourceId = typeof link.source === 'object' ? link.source.id : link.source;
            const targetId = typeof link.target === 'object' ? link.target.id : link.target;
            // 如果连接的两端都是可见节点，且这个连接还不存在
            if (visibleNodeIds.has(sourceId) &&
                visibleNodeIds.has(targetId) &&
                !existingLinks.has(`${sourceId}-${targetId}`)) {
                allLinks.push({
                    source: sourceId,
                    target: targetId,
                    weight: link.weight
                });
            }
        });

        // 更新图数据
        if (newNodes.length > 0 || allLinks.length > 0) {
            myGraph.graphData({
                nodes: [...graphData.nodes, ...newNodes],
                links: [...graphData.links, ...allLinks]
            });

            // 如果category是colorgroup, 就把links长度调小, 并且子节点围绕当前父节点
            // const isColorgroupNode = isColorgroup(node.category);
            // 修改colorgroup节点位置计算
            // if (isColorgroupNode){
            const parentNode = node;
            const radius = 80;

            newNodes.forEach((newNode, index) => {
                // 使用节点ID和索引生成确定性的种子
                const seed1 = simpleHash(newNode.id + '_theta') + index;
                const seed2 = simpleHash(newNode.id + '_phi') + index;

                // 使用确定性的随机数
                const theta = seededRandom(seed1) * 2 * Math.PI;
                const phi = Math.acos(2 * seededRandom(seed2) - 1);

                // 球坐标转换为笛卡尔坐标
                newNode.fx = parentNode.x + radius * Math.sin(phi) * Math.cos(theta);
                newNode.fy = parentNode.y + radius * Math.sin(phi) * Math.sin(theta);
                newNode.fz = parentNode.z + radius * Math.cos(phi);
            });
        }


        // let selectedCategorySet = new Set(selectedCategory.value)
        // myGraph.linkVisibility((link) => {
        //     return selectedCategorySet.has(link.source.category) && selectedCategorySet.has(link.target.category)
        // })

        setTimeout(() => {
            myGraph.linkThreeObject(link => { // 把点连成线, 并且设置线的材质, 使用的是3d线条, 默认不需要写这个, 但线就会是2d的
                return getLinkThreeObject(link, 0.5, lineOpacityCoef.value / 200);
            })
        }, 5)

        setTimeout(() => {
            const updatedData = myGraph.graphData();
            updatedData.nodes.forEach(n => {
                n.fx = n.x;
                n.fy = n.y;
                n.fz = n.z;
            });
        }, 5); // 3秒后固定位置，让节点有足够时间飘移到合适位置
    } else {
        collapseNode(node);
    }
}

// 收起节点的函数
function collapseNode(node) {


    // 获取真实子节点
    let parentSet = new Map(Object.entries(toRaw(currentData.value.parent_child)));
    let childList = parentSet.get(node.id);


    // // 清理展开计数器
    const graphData = myGraph.graphData();
    const linksToRemove = new Set();
    // const nodesToRemove = findNodesToRemove(node, graphData);
    const nodesToRemove = new Set();

    myGraph.graphData().nodes.forEach(n => {
        if (childList.includes(n.id)) {
            nodesToRemove.add(n.id);
        }
    })

    console.log('nodesToRemove:', nodesToRemove);

    // 找出所有需要移除的连线（包括被移除节点与其他节点之间的所有连线）
    graphData.links.forEach(link => {
        const sourceId = typeof link.source === 'object' ? link.source.id : link.source;
        const targetId = typeof link.target === 'object' ? link.target.id : link.target;

        // 如果连线的任意一端是要被移除的节点，这条连线就要被移除
        if (nodesToRemove.has(sourceId) || nodesToRemove.has(targetId)) {
            linksToRemove.add(`${sourceId}-${targetId}`);
        }
    });

    // 更新图数据
    if (nodesToRemove.size > 0) {
        const updatedNodes = graphData.nodes.filter(n => !nodesToRemove.has(n.id));
        const updatedLinks = graphData.links.filter(link => {
            const sourceId = typeof link.source === 'object' ? link.source.id : link.source;
            const targetId = typeof link.target === 'object' ? link.target.id : link.target;
            return !linksToRemove.has(`${sourceId}-${targetId}`);
        });

        // 更新图表数据
        myGraph.graphData({
            nodes: updatedNodes,
            links: updatedLinks
        });

        // 打印调试信息
        console.log('Removed links:', linksToRemove);
        console.log('expandedNodesMap:', expandedNodesMap);

    } // C0421451

    // 释放几何体内存
    graphData.links.filter(link => linksToRemove.has(link.id)).forEach(link => {
        if (link.__threeObj) {
            link.__threeObj.geometry.dispose();
        }
    });
}

// 5.5 计算两个点的距离
export function calcDist(node1, node2) {
    let distX = node1.x - node2.x;
    let distY = node1.y - node2.y;
    let distZ = node1.z - node2.z;
    return Math.sqrt(distX * distX + distY * distY + distZ * distZ);
}

// 5.11 决定哪些节点是否该显示label标签

export function calcThresholdOfNodeToShow(myGraph,) {
    // Calculate the minimum distance between the camera and all nodes in view;
    var camP = myGraph.cameraPosition();     // 获取相机位置
    const nodes = myGraph.graphData().nodes; // 获取所有节点

    let NodeDistArray = [];
    let minDistFromNodeToCam = Number.MAX_VALUE;
    // let selectedCategorySet = new Set(selectedCategory.value)

    // 收集节点信息
    for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (isInView(myGraph, node)) { //  && selectedCategorySet.has(node.category)
            // Node is in view, calculate the distance to the camera;
            let distFromNodeToCam = calcDist(node, camP)
            node.dist = distFromNodeToCam;
            if (distFromNodeToCam < minDistFromNodeToCam) {
                minDistFromNodeToCam = distFromNodeToCam;
            }
            NodeDistArray.push(node.size);
        }
    }

    // Descend Sorting
    NodeDistArray.sort(function (a, b) {
        return b - a;
    });
    // Get the number of nodes to display based on the closest distance and the distance from the camera to the origin when zooming to fit
    // 决定显示多少标签
    // 点标签
    let zoomScale = minDistFromNodeToCam / state.cameraOrigDist;
    let visibleNum = labelConfig.maxVisibleNum;
    if (zoomScale >= 0.7) {
        visibleNum = labelConfig.minVisibleNum;
    } else if (zoomScale <= 0.2) {
        visibleNum = labelConfig.maxVisibleNum
    } else {
        visibleNum = Math.round((zoomScale - 0.20) * ((labelConfig.minVisibleNum - labelConfig.maxVisibleNum) / 0.5) + labelConfig.maxVisibleNum);
    }

    // Fix NodeDistArray[visibleNum] is undefined when num of nodes in View less than NodeDistArray.length
    if (visibleNum < NodeDistArray.length) {
        return NodeDistArray[visibleNum]
    } else {
        return 0
    }
}

//
// 动态计算标签字体大小
export function calculateLabelFontSize(node, camera) {
    // 设置字体大小的范围
    const MIN_FONT_SIZE = labelConfig.minFontSize;
    const MAX_FONT_SIZE = labelConfig.maxFontSize;
    const MAX_DISTANCE = 500; // 最大参考距离

    // 计算节点到相机的距离
    const distance = calcDist(node, camera);

    // 使用指数衰减函数计算字体大小
    // 当距离为0时得到最大字体，距离增加时字体大小呈指数衰减
    const scale = Math.exp(-distance / MAX_DISTANCE);
    const fontSize = MIN_FONT_SIZE + (MAX_FONT_SIZE - MIN_FONT_SIZE) * scale;

    // 确保字体大小在允许范围内
    return Math.max(MIN_FONT_SIZE, Math.min(fontSize, MAX_FONT_SIZE)) * labelFontScale.value;
}

export let selectedTreeNodesSet = reactive(new Set());
export let selectedTreeCategorySet = reactive(new Set());

export let labelFontScale = ref(1);
export let labelFontOpacity = ref(70);